import { FOOTER } from "@/lib/testIds";
import { ArrowUpRight } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

const cols = [
  {
    title: "Stays",
    links: [
      { label: "All properties", to: "/properties" },
      { label: "Coastal escapes", to: "/properties?collection=coastal" },
      { label: "Quiet cabins", to: "/properties?collection=cabins" },
      { label: "City lofts", to: "/properties?collection=city" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About us", to: "/about-us" },
      { label: "Hosts", to: "/hosts/subscription" },
      { label: "FAQ", to: "/faq" },
      { label: "Contact", to: "/contact-us" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms", to: "/terms-and-conditions" },
      { label: "Booking policies", to: "/booking-policies" },
      { label: "Privacy", to: "/terms-and-conditions#" },
      { label: "Cookies", to: "/terms-and-conditions#" },
    ],
  },
];

export const Footer = () => {
  const [email, setEmail] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Please enter a valid email");
      return;
    }
    toast.success("You're on the list.");
    setEmail("");
  };

  return (
    <footer
      data-testid={FOOTER.root}
      className="relative mt-16 bg-foreground text-background md:mt-24"
    >
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 pt-16 pb-8 md:grid-cols-12 md:gap-16 md:px-10 md:pt-24 md:pb-10">
        <div className="md:col-span-6">
          <p className="mb-4 text-[10px] uppercase tracking-[0.2em] text-background/60 md:mb-6 md:text-xs">
            Newsletter — Field notes
          </p>
          <h3 className="font-display text-3xl leading-[1.05] tracking-tight md:text-5xl">
            Slow travel,
            <br />
            in your inbox.
          </h3>

          <form
            onSubmit={onSubmit}
            className="mt-8 flex max-w-md items-center border-b border-background/40 pb-3 md:mt-10"
          >
            <input
              data-testid={FOOTER.newsletterInput}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@somewhere.com"
              className="flex-1 bg-transparent text-base text-background placeholder:text-background/40 focus:outline-none"
            />
            <button
              type="submit"
              data-testid={FOOTER.newsletterSubmit}
              className="ml-4 inline-flex items-center gap-1 text-sm font-medium text-background transition-transform duration-300 hover:translate-x-1"
            >
              Subscribe <ArrowUpRight size={16} />
            </button>
          </form>
        </div>

        <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 md:col-span-6">
          {cols.map((c) => (
            <div key={c.title}>
              <p className="mb-4 text-[10px] uppercase tracking-[0.2em] text-background/60 md:mb-5 md:text-xs">
                {c.title}
              </p>
              <ul className="space-y-3 text-sm text-background/80">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.to}
                      className="transition-colors duration-300 hover:text-background"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-background/10">
        <div className="mx-auto max-w-[1400px] overflow-hidden px-5 pt-10 pb-6 md:px-10 md:pt-14 md:pb-8">
          <p
            data-testid={FOOTER.wordmark}
            className="font-display text-[24vw] font-medium leading-[0.9] tracking-tight md:text-[14rem]"
          >
            StayEasy<span className="text-primary">.</span>
          </p>
          <div className="mt-6 flex flex-col justify-between gap-3 text-xs text-background/50 md:mt-8 md:flex-row md:gap-4">
            <p>© 2026 StayEasy. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-background">Privacy</a>
              <a href="#" className="hover:text-background">Terms</a>
              <a href="#" className="hover:text-background">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
